import { ThunkAction } from 'redux-thunk'

import { PersonFormData } from 'admin/components/pages/PersonForm'
import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import { State } from 'admin/redux/ducks'
import { AdministratorType, OrgAccountType } from 'admin/types'
import createApiReducer, { requestDataFor, receiveDataFor, handleErrorFor } from 'redux/utils/createApiDuck'
import { APIState, AdminTypes, AlertLevels } from 'types'

const moduleName = `${config.appName  }/orgAccountAdmin`

export default createApiReducer(moduleName)

export function fetchOrgAccountAdmin(orgAccountId: string, kimId: number): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }: reduxDependenciesType) => {
    dispatch(requestDataFor(moduleName)())
    return api.getOrgAccount(orgAccountId)
      .then((data: OrgAccountType) => {
        const existingAdmin = data.administrators.find((admin) => {
          return admin.kimId === kimId && (admin.administratorType === AdminTypes.ACCOUNT_ADMIN || admin.administratorType === AdminTypes.ORG_ADMIN)
        })
        if (existingAdmin) {
          dispatch(receiveDataFor(moduleName)(existingAdmin))
          return existingAdmin
        } 
          throw new Error('ACCOUNT_ADMIN_NOT_FOUND')
        
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function createOrgAccountAdmin(orgAccountId: string, data: PersonFormData): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }: reduxDependenciesType) => {
    dispatch(requestDataFor(moduleName)())
    return api.createAdministrator(orgAccountId, data, AdminTypes.ACCOUNT_ADMIN)
      .then((kimId: number) => {
        // TODO: Use and return kimId when API returns it
        // dispatch(fetchOrgAccountAdmin(orgAccountId, kimId))
        // return kimId
        
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function updateOrgAccountAdmin(orgAccountId: string, kimId: number, data: PersonFormData): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }: reduxDependenciesType) => {
    dispatch(requestDataFor(moduleName)())
    return api.updatePersonInfo(orgAccountId, kimId, data)
      .then(() => {
        dispatch(fetchOrgAccountAdmin(orgAccountId, kimId))
        
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function inactivateAdministrator(orgAccountId: string, kimId: number): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }: reduxDependenciesType) => {
    const {login} = getState()
    // check for deleting self
    if (login.data.kimId === kimId) {
      const error = {
        level: AlertLevels.WARNING,
        message: 'CANNOT_DELETE_OWN_ADMIN_ACCOUNT',
      }
      dispatch(handleErrorFor(moduleName)(error))
      return Promise.reject(error)
    }
    dispatch(requestDataFor(moduleName)())
    return api.inactivateAccountAdministrator(orgAccountId, kimId)
      .then((result) => {
        dispatch(receiveDataFor(moduleName)(result))
      })
      .catch((error) => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export interface OrgaAccountAdminState extends APIState {
  data: AdministratorType
}
